module.exports = __webpack_public_path__ + "static/media/Onboarding2.1c9e29c0.png";